import type { ChatHistoryItem } from "../../api";
import { IHistoryProvider, HistoryProviderOptions, GiveFeedbackParams } from "./IProvider";

export class NoneProvider implements IHistoryProvider {
    getProviderName = () => HistoryProviderOptions.None;
    resetContinuationToken(): void {
        return;
    }
    async getNextItems(count: number): Promise<ChatHistoryItem[]> {
        return [];
    }

    async getItem(id: string): Promise<null> {
        return null;
    }
    async deleteItem(id: string): Promise<void> {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async giveFeedback(_params: GiveFeedbackParams): Promise<void> {
        return;
    }
}
